<template>
 <div v-if="imageLoader" class="fullscreen">
   <div class="message">
   <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-file-added="fileAdded" @vdropzone-complete="afterComplete"></vue-dropzone>
  <button @click="close">Cancel</button>
  </div>
   </div>
</template>

<script>
// @ is an alias to /src


import firebase from 'firebase'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  components: {
   vueDropzone: vue2Dropzone
  },
  data() {
    return {
      file:null,
     dropzoneOptions: {
          url: 'https://httpbin.org/post',
          thumbnailWidth: 250,
          maxFilesize: 2.5,
          
          acceptedFiles:".jpg,.png",
          dictDefaultMessage:"Drop image file here.",
          headers: { "My-Awesome-Header": "header value" }
      }
        }
  },
  mounted(){
     
    },
    computed:{
     imageLoader(){
      return this.$store.getters.getShowImageLoader
    }
    },
    methods:{
      close(){
        
        if(this.file){
          this.$refs.myVueDropzone.removeFile(this.file)
        }
      this.$store.commit('setShowImageLoader',false)
    },
     fileAdded(file){
       console.log(file)
     },
     
      async afterComplete(file){
        
        const self=this
        let imagePath="images"
         if(this.imageLoader.imagePath){
           imagePath="images/"+this.imageLoader.imagePath
          }
        try{
          const metadata={
            contentType:"image/png",
            customMetadata:{
              width:file.width,
              height:file.height
            }
          }
          if(file.status=="success"){
          const storageRef=firebase.storage().ref()
         
          const imageRef=storageRef.child(imagePath+'/'+file.name)
          await imageRef.put(file,metadata);
          const imageInfo=await imageRef
          //await imageRef.updateMetadata(metadata)
          const downloadURL=await imageRef.getDownloadURL()
          
          this.$refs.myVueDropzone.removeFile(file)
          if(this.imageLoader.callback){
            this.imageLoader.callback(file.name,downloadURL,metadata.customMetadata)
          }
          this.$store.commit('setShowImageLoader',null)
          
          }else{
            this.file=file
           /* setTimeout(function(){
             
              self.$refs.myVueDropzone.removeFile(file)
            },5000)
            */
          }
        } catch(error){
          console.error(error )
        }

      }
    },
    watch:{
      
      
    },
  beforeDestroy() {
    
  },
}


</script>

<style lang="scss">
.bottom{
  position:absolute;
  bottom:10px;
}
.popInput{
  font-size:16px;
  margin:5px;
}
.fullscreen {
  z-index:1000;
  display:flex;
  padding:10px;
  justify-content: center;
  position:absolute;
  width:100%;
  height: 100%;
   align-items: center;
  
  background-color:#000000aa;

  .message{
    padding-top:10px;
    position:relative;
    display:flex;
    flex-direction:column;
    align-items: center;
    align-content:flex-end;
   
    min-width:280px;
    min-height:120px;
    background-color:#ccc;
    border-radius:5px;
    
    button{
      font-size:16px;
      margin:2px;
    }
  }
  .vue-dropzone {
    border-radius: 5px;
  }
  .flex-item{
     height:30px;
    }
}

</style>